import './controls.css';
import type { ReactNode } from 'react';

export interface ControlTileProps {
  label: string;
  status?: ReactNode;            // korte huidige stand (bv "Auto" of "Off")
  children: ReactNode;            // de knop(pen) of toggle
  accent?: string;
  hint?: string;                  // tooltip-achtige extra context (verborgen op desktop)
  subline?: ReactNode;            // footer-tekst onder body — live state of static template
  restricted?: boolean;           // togglet .is-restricted class voor rol-based hiding demo
}

export function ControlTile({ label, status, children, accent, hint, subline, restricted }: ControlTileProps) {
  const classes = ['control-tile', restricted ? 'is-restricted' : ''].filter(Boolean).join(' ');
  return (
    <div className={classes} style={{ ['--accent' as any]: accent }}>
      <div className="control-head">
        <div className="control-label">{label}</div>
        {status && <div className="control-status">{status}</div>}
      </div>
      <div className="control-body">{children}</div>
      {subline != null && subline !== '' && <div className="control-subline">{subline}</div>}
      {hint && <div className="control-hint">{hint}</div>}
    </div>
  );
}
